import { createApp } from 'vue'
import App from './App.vue'
import {devtools} from '@vue/devtools'

const app = createApp(App).use(devtools)

if (process.env.NODE_ENV === 'development') {
  if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in window) {
  // Here__ VUE_ DEVTOOLS_ GLOBAL_ HOOK__ . Vue assigns a createapp instance
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app
  }
  app.config.devtools = true
}

app.mount('#app')
